import React from 'react';

import { FaAngleDown } from 'react-icons/fa';

import { convertReportKeyToTitle } from '../../helpers/convertReportKeyToTitle';
import { ReportTableType } from '../../types/ReportTableType';

interface ReportTypeSelectionDropdownProps {
    selectedItem: ReportTableType;
    selectionItems: ReportTableType[];
    additionalClasses?: string;
    onSelectItem: (item: string) => void;
    disabled?: boolean;
}
const ReportTypeSelectionDropdown: React.FC<ReportTypeSelectionDropdownProps> = (props) => {
    const { selectedItem, selectionItems, additionalClasses, onSelectItem, disabled } = props;

    const ref = React.useRef<HTMLDivElement>(null);

    const [isDropdownActive, setIsDropdownActive] = React.useState<boolean>(false);

    const onTriggerHandler = () => {
        setIsDropdownActive(!isDropdownActive);
    };

    const onBlurHandler = () => {
        setIsDropdownActive(false);
    };

    const onSelectHandler = (item: string) => {
        onSelectItem(item);
        setIsDropdownActive(!isDropdownActive);
    };

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setIsDropdownActive(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref]);

    return (
        <div className={`dropdown ${isDropdownActive ? 'is-active' : ''} ${additionalClasses}`} ref={ref}>
            <div className={'dropdown-trigger'} onClick={onTriggerHandler}>
                <button
                    className="button is-light"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu3"
                    disabled={disabled}
                >
                    <span>{convertReportKeyToTitle(selectedItem)}</span>
                    <span className="icon is-small">
                        <FaAngleDown />
                    </span>
                </button>
            </div>
            <div className="dropdown-menu" id="dropdown-menu3" role="menu">
                <div className="dropdown-content">
                    <div className="head">Afficher :</div>
                    {selectionItems.map((item) => (
                        <a
                            className="dropdown-item"
                            key={item}
                            onClick={() => {
                                onSelectHandler(item);
                            }}
                        >
                            {convertReportKeyToTitle(item)}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ReportTypeSelectionDropdown;
